<template>

  <div class="ob-content">
    <ob-filters>
      <issues-filters @change="$refs.table.refresh()"></issues-filters>
    </ob-filters>

    <v-card>
      <issues-table
        ref="table"
        :source="source"
        :state="table"
        @change="saveTable($event)"
        @click="$router.push({ name: 'issues/id', params: { id: $event.id} })"
      />
    </v-card>
  </div>

</template>

<script>
import moment from 'moment'
import {mapMutations, mapState} from 'vuex'
import ApiService from '../../services/api.service.es6'
import IssuesFilters from './components/issues-filters'
import IssuesTable from './components/issues-table'
import ObFilters from '../shared/components/filters'

export default {
  data () {
    return {
      source: args => ApiService.findAllPaginated('issues', this.apiFilters, args.sort, args.pagination)
    }
  },

  computed: {
    ...mapState('filters/issues', [
      'filters',
      'table'
    ]),

    apiFilters () {
      const days = this.$store.state.issues.limitDays

      return {
        dateTo: moment().add(days, 'days').format(),
        type: this.filters.type,
        closedIssues: this.filters.closed,
        filter: [
          { name: 'assets.id', value: this.filters.assets },
          { name: 'assetTypes.id', value: this.filters.assetTypes },
          { name: 'users.id', value: this.filters.users },
          { name: 'issues.code', value: this.filters.issueCodes }
        ]
      }
    }
  },

  methods: {
    ...mapMutations('filters/issues', [
      'saveTable'
    ])
  },

  components: {
    ObFilters,
    IssuesTable,
    IssuesFilters
  }
}
</script>

<style scoped lang="scss">

</style>
